import { createGlobalStyle } from "styled-components";

const HomeSpecific = createGlobalStyle`

    body{
        background: #0D0D0D;
        overflow: hidden;
        color: #F2F2F2;
        font-family: "DM Sans"
    }

`

export default HomeSpecific;